module.exports = __webpack_public_path__ + "static/media/personTechnology.e5ffb96f.png";